// src/components/profile/EditableSection.jsx
import React from 'react';

const EditableSection = ({ title, icon, children, isEditing, onEdit, onSave, onCancel, isOwnProfile }) => {
  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold flex items-center text-blue-400">
          {icon && <span className="mr-2">{icon}</span>}
          {title}
        </h3>
        
        {isOwnProfile && (
          !isEditing ? (
            <button 
              onClick={onEdit}
              className="text-sm text-blue-400 hover:text-blue-300 transition-colors duration-200 flex items-center"
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
              </svg>
              Edit
            </button>
          ) : (
            <div className="flex space-x-2">
              <button 
                onClick={onSave}
                className="text-sm text-green-400 hover:text-green-300 transition-colors duration-200 flex items-center"
              >
                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Save
              </button>
              <button 
                onClick={onCancel}
                className="text-sm text-red-400 hover:text-red-300 transition-colors duration-200 flex items-center"
              >
                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Cancel
              </button>
            </div>
          )
        )}
      </div>
      
      {children}
    </div>
  );
};

export default EditableSection;
